package services.auth.http

import it.neckar.rest.RestResponse
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface AddNewUserResponse : RestResponse<UserLoginName> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: UserLoginName) : AddNewUserResponse, RestResponse.GoodResponse<UserLoginName>

  @Serializable
  @SerialName("bad/Failed")
  data class Failed(val errorType: ErrorType) : AddNewUserResponse, RestResponse.BadResponse<UserLoginName> {
    enum class ErrorType {
      UserAlreadyExists,
      InvalidPassword,
      FailToFetch,
    }
  }

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: UserLoginName): AddNewUserResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(errorType: Failed.ErrorType): AddNewUserResponse = Failed(errorType)
  }
}
